import { DialogContent, DialogTitle } from "@mui/material"
import { DataInputDialog } from "lib/@dialogs/data-input-dialog"
import { CreateRuleSetFormBody } from "./create-rule-set-form-body"

export function RuleSetEditDetailsDialog({
    currentRuleSetId,
    name,
    description,
    defaultAction,
    regime,
    assetRegister,
}) {
    return (
        <DataInputDialog
            initialValue={{
                name: name || "",
                description: description || "",
                regime: regime || null,
                assetRegister: assetRegister || null,
                includeByDefault: defaultAction !== "exclude",
            }}
            okCaption="Save"
            okDisabled={isInvalid}
        >
            <DialogTitle sx={{ pb: 3 }}>Edit Rule Details</DialogTitle>
            <DialogContent sx={{ pb: 0.5 }}>
                <CreateRuleSetFormBody currentRuleSetId={currentRuleSetId} />
            </DialogContent>
        </DataInputDialog>
    )
}

function isInvalid(v) {
    if (!v?.name?.trim()) return true
    return false
}
